import { EcommerceTechTypeEnum } from "src/app/order/enums/ecommerce-tech-type.enum";
import { ECommerceFunctionalitiesEnum } from "src/app/order/components/complementary-information/e-commerce/models/e-commerce-funcionalities.model";

export class EcommerceComplementaryInfoModel {
  public extraFunctionalities: ECommerceFunctionalitiesEnum[];
  public link: string;
  public productOrServiceDetails: string;
  public describeHowWillBeDelivered: string;
  public maxValueOfTransaction: number;
  public hasAntiFraudService: boolean;
  public transactionRiskAware: boolean;
  public technicalContact: TechnicalContactModel;
  public nameGatewayOrIntegrator: string;
  public techType: EcommerceTechTypeEnum;
}

export class TechnicalContactModel {
  public name: string;
  public email: string;
  public primaryPhone: string;
  public secondaryPhone: string;
  public mobileNumber: string;
}
